const EMPTY_OBJECT = {};

const getThreadContentByThreadId = (threadContentItems = []) => {
  if (!Array.isArray(threadContentItems) || threadContentItems.length < 1) {
    return EMPTY_OBJECT;
  }

  const mapped = {};

  for (const threadContent of threadContentItems) {
    const threadId = String(threadContent?.threadId || '').trim();

    if (!threadId) {
      continue;
    }

    mapped[threadId] = threadContent;
  }

  return Object.keys(mapped).length > 0 ? mapped : EMPTY_OBJECT;
};

export default getThreadContentByThreadId;
